import React, { useState } from 'react';

import { Box, Button, Col, Link, Paper, Row, Typography } from 'components/AORedesign';
import ClaimsReportingModal, { REPORT_A_CLAIM_DIALOG_CONTENT_MAP } from './ClaimsReportingModal';
import OneStopClaimReporting from './OneStopClaimReporting';

// eslint-disable-next-line react/prop-types
const LinkButton = ({ children, value, onClick }) => (
  <Button
    variant="text"
    color="secondary"
    style={{ textTransform: 'none', fontSize: '1rem', padding: '0', lineHeight: '20px', textAlign: 'left', justifyContent: 'flex-start' }}
    onClick={() => onClick(value)}>
    {children}
  </Button>
);

const ClaimsReport = () => {
  const [claimsReportingModalContent, setClaimsReportingModalContent] = useState('');

  const handleCloseClaimsReportingModal = () => setClaimsReportingModalContent('');

  const handleButtonOnClick = (view) => {
    setClaimsReportingModalContent(view);
  };

  return (
    <>
      <Typography variant="h5" style={{ marginBottom: 16 }}>
        Report a Claim
      </Typography>

      <Row mb={2} justifyContent="space-between" spacing={2}>
        <Col xs={4}>
          <OneStopClaimReporting />
        </Col>

        <Col xs={5}>
          <Paper>
            <Typography id="ClaimsTypographySubtitle" variant="h6" style={{ marginBottom: 16 }}>
              Auto Claims Programs
            </Typography>
            <Box display="flex" flexDirection="column" alignItems="flex-start" style={{ gap: '16px' }}>
              <LinkButton
                onClick={() => handleButtonOnClick(REPORT_A_CLAIM_DIALOG_CONTENT_MAP.GlassProgram)}
                style={{ textAlign: 'left', justifyContent: 'flex-start' }}>
                Glass Program
              </LinkButton>
              <LinkButton onClick={() => handleButtonOnClick(REPORT_A_CLAIM_DIALOG_CONTENT_MAP.TotalLoss)}>Navigating a Total Loss</LinkButton>
              <LinkButton onClick={() => handleButtonOnClick(REPORT_A_CLAIM_DIALOG_CONTENT_MAP.MethodOfInspection)}>
                Method of Inspection Auto Repair Options
              </LinkButton>
              <Link id="ValueInPartnershipProgram" color="secondary" href={'https://drplocatorspa.amfam.com/?id=D8958C3071714434'} endIcon="openInNew">
                Value in Partnership (VIP) Program
              </Link>
            </Box>
          </Paper>

          <Box mb={2} />

          <Paper>
            <Typography id="ClaimsTypographySubtitle" variant="h6" style={{ marginBottom: 16 }}>
              Property Claims Programs
            </Typography>
            <LinkButton onClick={() => handleButtonOnClick(REPORT_A_CLAIM_DIALOG_CONTENT_MAP.PropertyClaims)}>
              Property Claims After Hours Emergency Response
            </LinkButton>
          </Paper>
        </Col>

        <Col xs={3}>
          <Paper>
            <Typography id="ClaimsTypographySubtitle" variant="h6" style={{ marginBottom: 16 }}>
              Workers Compensation Claims
            </Typography>
            <LinkButton onClick={() => handleButtonOnClick(REPORT_A_CLAIM_DIALOG_CONTENT_MAP.WorkersCompensation)}>Workers Compensation Claims</LinkButton>
          </Paper>

          <Box mb={2} />

          <Paper>
            <Typography id="ClaimsTypographySubtitle-bonds" variant="h6" style={{ marginBottom: 16 }}>
              Surety and Fidelity Bonds Claims
            </Typography>

            <Row spacing={2}>
              <Col xs={3}>
                <Typography color="textSecondary" component="div">
                  <Box fontSize={12}>EMAIL</Box>
                </Typography>
              </Col>
              <Col xs={9}>
                <Typography component="div">
                  <Box
                    component="a"
                    href="mailto:Bondclaims@msagroup.com"
                    fontSize={14}
                    style={{ textDecoration: 'none', wordWrap: 'break-word', overflowWrap: 'break-word', whiteSpace: 'normal', maxWidth: '100%' }}
                    color="primary.main">
                    Bondclaims@msagroup.com
                  </Box>
                </Typography>
              </Col>
            </Row>

            <Row spacing={2} mb={3}>
              <Col xs={3}>
                <Typography color="textSecondary" component="div">
                  <Box fontSize={12}>MAIL</Box>
                </Typography>
              </Col>
              <Col xs={9}>
                <Typography component="div">
                  <Box fontSize={14}>
                    Bond Claims
                    <br />
                    NGM Insurance Company
                    <br />
                    55 West Street
                    <br />
                    Keene, NH 03431
                  </Box>
                </Typography>
              </Col>
            </Row>
          </Paper>
        </Col>
      </Row>

      {claimsReportingModalContent && (
        <ClaimsReportingModal claimsReportingModalContent={claimsReportingModalContent} handleCloseClaimsReportingModal={handleCloseClaimsReportingModal} />
      )}
    </>
  );
};

export default ClaimsReport;
